import { IAugmentedJQuery, IDirective, IDirectiveFactory, ITimeoutService, IAttributes, IScope } from "angular";
import { offset } from "../dom";

export class LazySrcWrapperController {
  public images: HTMLElement[] = [];
  private wrapper: HTMLElement;

  public static $inject = ["$scope", "$timeout"];

  constructor(private $scope: IScope, private $timeout: ITimeoutService) {}

  public setWrapper(wrapper: HTMLElement): void {
    this.wrapper = wrapper;
    const checkCallback = () => this.checkForVisibleImages(wrapper);

    // on window resize
    window.addEventListener("resize", checkCallback);

    // if scope changes -> check for newly added images and render them
    // this.$scope.$watch(checkCallback);

    // on scroll
    wrapper.addEventListener("scroll", checkCallback);

    // on custom event
    this.$scope.$on("lazySrcTriggered", checkCallback);

    this.$scope.$on("$destroy", () => window.removeEventListener("resize", checkCallback));
  }

  public addImage(image: HTMLElement): void {
    if (!this.images.includes(image)) {
      this.images.push(image);
      this.$timeout(() => this.checkForVisibleImages(this.wrapper), 0);
    }
  }

  public removeImage(image: HTMLElement): void {
    this.images = this.images.filter((i) => i !== image);
  }

  private checkForVisibleImages(wrapper: HTMLElement): void {
    const wrapperOffset = offset(wrapper);
    let wrapperOffsetTop: number, wrapperOffsetBottom: number;
    let imageOffsetTop: number, imageOffsetBottom: number;

    for (const image of this.images) {
      const imageOffset = offset(image);

      if (wrapperOffset && imageOffset) {
        wrapperOffsetTop = wrapperOffset.top;
        wrapperOffsetBottom = wrapperOffsetTop + wrapper.offsetHeight;

        imageOffsetTop = imageOffset.top;
        imageOffsetBottom = imageOffsetTop + image.offsetHeight;

        if (
          (wrapperOffsetTop <= imageOffsetTop && imageOffsetTop <= wrapperOffsetBottom) ||
          (wrapperOffsetTop <= imageOffsetBottom && imageOffsetBottom <= wrapperOffsetBottom)
        ) {
          image.setAttribute("src", image.getAttribute("lazy-src"));
          this.removeImage(image);
        }
      }
    }
  }
}

export class LazySrcWrapper implements IDirective {
  public restrict = "A";
  public controller = LazySrcWrapperController;

  public link(scope: IScope, element: IAugmentedJQuery, attr: IAttributes, ctrl: LazySrcWrapperController): void {
    ctrl.setWrapper(element[0]);
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new LazySrcWrapper();
    directive.$inject = [];
    return directive;
  }
}
